export default __webpack_public_path__ + "static/media/brainstorm.1f8dbebd.jpg";